<ion-content class="container">
  <ion-row *ngIf="!router.url.includes('Setup')">
    <ion-col size="12" size-md="9" class="pl-15 pr-0 pb-0">
      <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
        <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
          (selectedTabChange)="tabTypeChanged($event)">
          <mat-tab label="Dashboard"
            *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  speed
                </span>Dashboard</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Survey Master"
            *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  group
                </span>Survey Master</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="My Master" *ngIf="loggedInUserRole == 'Employee' || loggedInUserRole == 'HOD' ||
          loggedInUserRole == 'Manager'">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  account_balance_wallet
                </span>My Survey</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Reports">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  description
                </span>Reports</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ion-col>
    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="isShowDesktopView borderbottomForTab pl-10 pt-10 pr-10"
      *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && !mobileResponsiveService.hideForTabletAndBelow">
      <div class="center-content float-right">
        <div>
          <span class="cp fs-14 fs_12ForMobile link font_regular center-content mr-20" (click)="onClickLogs('Logs')">
            <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
        </div>
        <div>
          <button type="button" class="ess_Btn fs-14 fs_12ForMobile float-right center-content mr-5"
            [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
            <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
        </div>
      </div>
    </ion-col>
  </ion-row>


  <!-- --------------------------------------SetUp----------------------------------- -->

  <div class="modal fade" [style.display]="showSetupPopup? 'block' : 'none'" *ngIf="!mobileResponsiveService.hideForTabletAndBelow">
    <div class="modal-dialog">
      <div class="modal-content">
        <ion-row class="p-0  headerBreadcrumb">
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
            <div class="d-flex headerBreadcrumb">
              <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickRedirectToDashboard()">
              <label class="font_semibold fs-16 fs_14ForMobile ml-10 mt-5 black_color" (click)="onClickRedirectToDashboard()">
                <span class="cp">Employee Satisfaction Survey</span> / <span
                  [style.color]="buttonColorName">Setup</span></label>
            </div>
          </ion-col>
          <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="text-right">
            <div class="d-inline-flex p-5">
              <button type="button" class="back_btn mr-10" (click)="onClickRedirectToDashboard()">Cancel</button>
              <button [disabled]="isPublished" [ngClass]="{'disableBtn' : isPublished}" type="button"
                class="ess_Btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName"
                (click)="updateSurvey()">Save</button>
              <button [disabled]="isPublished" [ngClass]="{'disableBtn' : isPublished}" type="button"
                class="ess_Btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName"
                (click)="onClickPublishBtn()">Publish</button>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="modal-body p-20">
        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_bold fs-14 fs_12ForMobile">Employee Satisfaction Survey</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row>
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                        (selectionChange)="getessName()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="createServeyBtn">
                      <button class="ess_Btn fs-14 fs_12ForMobile" [disabled]="disableCreateSurveyBtn()"
                        [ngClass]="{'disableBtn':disableCreateSurveyBtn()}" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Survey')">+ Create Survey</button>
                    </div>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
                        (selectionChange)="getessByID()">
                        <mat-option *ngFor="let item of essNamesList" [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </div>
        </div>

        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_bold fs-14 fs_12ForMobile">Setup</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row>
              <ion-col size="12" size-md="9">
                <div>
                  <table class="surveyTable">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Status</th>
                       
                        <!-- <th *ngIf="!isPublished || selectedSurveyStatus == 'Active'"></th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <label *ngIf="!isEditActive" class="fs-14 fs_12ForMobile regular">{{selectedSurveyName}}</label>
                          <mat-form-field *ngIf="isEditActive" class="custom-input w-80 mat-height40 mat-input-style">
                            <input matInput placeholder="Survey" [disabled]="selectedSurveyStatus == 'Active'"
                              class="font_regular" [(ngModel)]="selectedSurveyName">
                          </mat-form-field>
                        </td>
                        <td>
                          <label *ngIf="!isEditActive" class="fs-14 fs_12ForMobile regular">{{selectedSurveyStartDate |
                            date:'dd-MM-yyyy'}}</label>
                          <mat-form-field *ngIf="isEditActive" class="custom-input w-80 mat-height40 mat-input-style">
                            <input matInput dateInput [disabled]="selectedSurveyStatus == 'Active'"
                              [matDatepicker]="startDatePicker" placeholder="DD/MM/YYYY"
                              [(ngModel)]="selectedSurveyStartDate" >
                            <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                          </mat-form-field>
                        </td>
                        <td>
                          <label *ngIf="!isEditActive" class="fs-14 fs_12ForMobile regular">{{selectedSurveyEndDate |
                            date:'dd-MM-yyyy'}}</label>
                          <mat-form-field *ngIf="isEditActive" class="custom-input w-80 mat-height40 mat-input-style">
                            <input matInput dateInput [matDatepicker]="endDatePicker" placeholder="DD/MM/YYYY"
                              [(ngModel)]="selectedSurveyEndDate" >
                            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                          </mat-form-field>
                        </td>
                        <td class="tableDisableTd">
                          <!-- {{ isSurveyCompleted() ? 'Completed' : selectedSurveyStatus }} -->
                          {{ isSurveyCompleted() }}
                        </td>
                        <!--    
                        <td class="tableDisableTd"
                          *ngIf="!isPublished || selectedSurveyStatus == 'Active' || selectedSurveyStatus == 'Published_Not_Started'">
                          <span *ngIf="isEditActive" (click)="closeSurveyEdit()"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <img *ngIf="!isEditActive" class="ml-5 cp imgEdit" title="Edit" (click)="editSurvey()"
                            src="././assets/icon/edit.png"   [ngClass]="{ 'disabled': isSurveyExpired }">
                          <span *ngIf="isEditActive" (click)="updateSurvey()"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Can HR admin see Reports/ dashboards <span
                    class="red-cl">&nbsp;*</span></div>
                <div class="mt-10">
                  <mat-radio-group aria-label="Select an option" [(ngModel)]="isShowDashboardToHR"
                    class="fs-14 fs_12ForMobile font_semibold" [disabled]="isPublished">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false" class="pl-10">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Employees to participate in the survey</div>
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey">Location <span class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Location'"
                        [settings]="dropdownSettings" (onSelect)="getBandsListForEssSetup()"
                        (onDeSelect)="onDeSelectLocationSetup()" (onSelectAll)="selectAllLocationSetup($event)"
                        (onDeSelectAll)="onDeSelectAllLocationSetup()" [data]="getLocationList"
                        [(ngModel)]="selectedLocationForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey">Band <span class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Band'" [settings]="dropdownSettings"
                        (onSelect)="getGradesListForEssSetup()" (onDeSelect)="onDeSelectBandSetup()"
                        (onSelectAll)="selectAllBandSetup($event)" (onDeSelectAll)="onDeSelectAllBandSetup()"
                        [data]="getBandList" [(ngModel)]="selectedBandForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey">Grade <span class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Grade'"
                        [settings]="dropdownSettings" (onSelect)="getDeptListForEssSetup()"
                        (onDeSelect)="onDeSelectGradeSetup()" (onSelectAll)="selectAllGradeSetup($event)"
                        (onDeSelectAll)="onDeSelectAllGradeSetup()" [data]="getGradeList"
                        [(ngModel)]="selectedGradeForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile text_grey">Function<span class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Function'"
                        [settings]="dropdownSettings" (onSelect)="onSelectFunctionSetup()"
                        (onDeSelect)="onDeSelectFunctionSetup()" (onSelectAll)="selectAllFunctionSetup($event)"
                        (onDeSelectAll)="onDeSelectAllFunctionSetup()" [data]="getFunctionList"
                        [(ngModel)]="selectedFunctionForSetup">
                      </ng-multiselect-dropdown>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="mt-10 fs-14 fs_12ForMobile">Date of Joining ( Survey Cut-Off )<span class="red-cl">&nbsp;*</span></div>
                    <div class="mt-10">
                      <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
                        <input matInput readonly dateInput [matDatepicker]="dojDatePicker" placeholder="DD/MM/YYYY"
                          [(ngModel)]="surveyDateOfJoining">
                        <mat-datepicker-toggle matIconSuffix [for]="dojDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #dojDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </ion-col>

                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <button type="button" class="ess_Btn fs-14 fs_12ForMobile mt-35 center-content mr-5"
                      [style.background-color]="buttonColorName"
                      (click)="onClickOpenCreateSurveyPopup('View Employees')">View Employees</button>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Rating</div>
                <div class="mt-10">
                  <ion-row>
                    <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
                      <table class="surveyTable">
                        <thead>
                          <tr>
                            <th>Question type</th>
                            <th>Rating</th>
                            <th>Rating Definition</th>
                            <th *ngIf="!isPublished"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of ratingList; let i = index">
                            <td>
                              <ng-select [clearable]="false" class="w170 mat mat-height40" placeholder="Select"
                                [(ngModel)]="item.questionType" (change)="onQuestionTypeChange(item,i)">
                                <ng-option [value]="'Rating Based'">Rating Based</ng-option>
                                <ng-option *ngIf="!isOpenEnded" [value]="'Open Ended'">Open Ended</ng-option>
                              </ng-select>
                            </td>
                            <td>
                              <mat-form-field *ngIf="item.questionType == 'Rating Based'"
                                class="custom-input w170 mat-height40 mat-input-style">
                                <input type="number" matInput placeholder="Type here" class="font_regular"
                                  [(ngModel)]="item.rating" (keypress)="validateInputRating($event)">
                              </mat-form-field>
                            </td>
                            <td>
                              <mat-form-field *ngIf="item.questionType == 'Rating Based'"
                                class="custom-input w170 mat-height40 mat-input-style">
                                <input type="text" matInput placeholder="Type here" class="font_regular"
                                  [(ngModel)]="item.ratingDefinition" maxlength="255">
                              </mat-form-field>
                            </td>
                            <td *ngIf="!isPublished">
                              <div class="tableAddRemoveIcon">
                                <img *ngIf="i === ratingList.length - 1" class="cp" title="Add"
                                  src="././assets/icon/Plus_icon.svg" (click)="createRatingAddTableRow()">
                                <img *ngIf="ratingList.length > 1" class="cp ml-5" title="Remove"
                                  src="././assets/icon/Minus_icon.svg" (click)="createRatingRemoveTableRow(i)">
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20 mb-10">Select Template</div>
                <!-- <div class="verticle-center mt-10">
                  <div> -->
                    <ng-select [clearable]="false" class="w-100 mw-sm-250 mat mat-height40" placeholder="Select"
                      [(ngModel)]="selectedTemplateColorName">
                      <ng-option *ngFor="let item of templateColorList" [value]="item.colorName">
                        <div class="d-flex">
                          <label title="{{item.colorName}} - {{item.stripcolor}}"
                            class="rounded-color-picker firstColorofPicker" [style.background-color]="item.stripcolor">
                          </label>
                          <label title="Background - {{item.backgroundColor}}"
                            class="ml-5 rounded-color-picker firstColorofPicker"
                            [style.background-color]="item.backgroundColor">
                          </label>
                          <span class="ml-10">{{item.colorName}}</span>
                        </div>
                      </ng-option>
                    </ng-select>
                  <!-- </div>
                </div> -->
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <div class="d-flex">
                  <div>
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Reminders <span class="red-cl">&nbsp;*</span></div>
                    <mat-radio-group aria-label="Select an option" class="fs-14 fs_12ForMobile font_semibold mt-10"
                      [(ngModel)]="onSeletReminderOption" [disabled]="isPublished">
                      <mat-radio-button [value]="true"> Yes</mat-radio-button>
                      <mat-radio-button [value]="false" class="pl-10">No</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="ml-30" *ngIf="onSeletReminderOption">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Set Reminders</div>
                    <mat-form-field>
                      <input matInput [(ngModel)]="latestSelectedDate" [matDatepicker]="picker"
                        [value]="latestSelectedDate" (dateChange)="addDate($event.value)" placeholder="Select Dates"
                        [min]="selectedSurveyStartDate" [max]="selectedSurveyEndDate" readonly>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker [dateClass]="dateClass"></mat-datepicker>
                    </mat-form-field>
                    <!-- <div>
                        <mat-chip *ngFor="let date of selectedDatesForReminder" (removed)="removeDate(date)">
                          {{ date | date: 'dd/MM/yyyy' }}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </div> -->
                  </div>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <ion-row>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Email Body</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/mail_Icon.svg" alt="createEmailBody"></div>
                      <button class="ess_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Email Body')">{{!isPublished?'+ Create':'View'}}</button>
                    </div>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Instructions</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/instructions_icon.svg" alt="createInstructions"></div>
                      <button class="ess_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Create Instructions')">{{!isPublished?'+ Create':'View'}}</button>
                    </div>
                  </ion-col>
                  <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
                    <div class="fs-14 fs_12ForMobile font_semibold mt-20">Submission Email</div>
                    <div class="content-box mt-20">
                      <div><img class="w50" src="././assets/icon/thumb_up_icon.svg" alt="createSubmissionEmial"></div>
                      <button class="ess_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"
                        (click)="onClickOpenCreateSurveyPopup('Submission Email')">{{!isPublished?'+ Create':'View'}}</button>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="fs-14 fs_12ForMobile font_semibold mt-20">Create Template</div>
                <div>
                  <div *ngFor="let table of dimensionsTemplateList; let tableIndex = index" class="mt-20">
                    <table class="surveyTable">
                      <thead>
                        <tr>
                          <th *ngIf="tableIndex > 0; else emptyHeader" class="tableAddRemoveIcon">
                            <img *ngIf="!isPublished" class="cp" title="Delete" src="././assets/icon/red_delete.svg"
                              (click)="createTemplateDeleteTable(tableIndex)">
                          </th>
                          <ng-template #emptyHeader>
                            <th></th>
                          </ng-template>
                          <th>Dimensions</th>
                          <th>Questions</th>
                          <th>Type (open/ rating)</th>
                          <th *ngIf="!isPublished"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of table.questions; let rowIndex = index;let isLast = last">
                          <td *ngIf="rowIndex === 0; else emptyCell" class="text-center">{{ tableIndex + 1 }}</td>
                          <ng-template #emptyCell>
                            <td></td>
                          </ng-template>
                          <td *ngIf="rowIndex === 0; else emptyDimension">
                            <mat-form-field class="custom-input w-80 mat-height40 mat-input-style">
                              <input type="text" matInput placeholder="Type text here" class="font_regular"
                                [(ngModel)]="table.dimensionName" maxlength="255">
                            </mat-form-field>
                          </td>
                          <ng-template #emptyDimension>
                            <td></td>
                          </ng-template>
                          <td>
                            <mat-form-field class="custom-input w-90 mat-input-style">
                              <textarea matInput placeholder="Type text here" [(ngModel)]="row.question"
                                maxlength="255"></textarea>
                            </mat-form-field>
                          </td>
                          <td>
                            <ng-select class="w170 mat mat-height40" placeholder="Select" [(ngModel)]="row.questionType"
                              [clearable]="false">
                              <ng-option *ngIf="isRatingBased" [value]="'Rating Based'">Rating Based</ng-option>
                              <ng-option *ngIf="isOpenEnded" [value]="'Open Ended'">Open Ended</ng-option>
                            </ng-select>
                          </td>
                          <td *ngIf="!isPublished">
                            <div class="tableAddRemoveIcon">
                              <img *ngIf="isLast" class="cp" title="Add" src="././assets/icon/Plus_icon.svg"
                                (click)="createTemplateAddTableRow(tableIndex)">
                              <img *ngIf="table.questions.length > 1" class="cp ml-5" title="Remove"
                                src="././assets/icon/Minus_icon.svg"
                                (click)="createTemplateRemoveTableRow(tableIndex, rowIndex)">
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                  <button *ngIf="!isPublished" class="ess_Btn fs-14 fs_12ForMobile center-content mt-20"
                    [style.background-color]="buttonColorName" (click)="createTemplateAddTable()">+ Add
                    Dimension</button>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------Dashboard------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == 'Dashboard'">
    <ion-row class="mt-20">
      <ion-col size="12" size-md="auto">
        <mat-form-field class="w150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="changeGlobalYear(); essNamesActiveAndCompleted(); getYearlyCounter()">
            <mat-option *ngFor="let item of yearsOfCompany" [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      
      <ion-col size="12" size-md *ngIf="!(!isShowDashboardToHR && loggedInUserRole == 'HR Admin')">
        <div class="d-flex phi-gap-12 dashboardInfoCard">
          <div class="cardBox w-100 mw-sm-250 phi-flex-center phi-gap-10 p-10 mb-md-15">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
              </div>
              <div class="text-wrapper">
                <p class="fs-14 fs_12ForMobile font_semibold">No of Surveys Created</p>
                <p class="mt-5 fs-14 fs_12ForMobile font_bold blue">{{noOfSurveysCreatedYearly}}</p>
              </div>
          </div>

          <div class="cardBox p-10 cp phi-flex-center phi-gap-10" (click)="dashboardCounterPopups('scoresOfSurveys')">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
              </div>
              <div class="text-wrapper">
                <p class="fs-14 fs_12ForMobile font_semibold">Scores of surveys</p>
                <p class="mt-5 fs-14 fs_12ForMobile font_bold blue">Max Avg. Score {{maxScoreYearly}} | Min Avg. Score {{minScoreYearly}} | Average score {{avgScoreYearly}}</p>
              </div>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="mt-20">
      <ion-col size="12" size-md="auto">
        <mat-form-field class="w150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyIDForDashboardGlobal" (selectionChange)="getEssByIdForDashboard(); changeGlobalSurveyId()">
            <mat-option *ngFor="let item of essNamesListForDashboard" [value]="item.id">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      
      <ion-col size="12" size-md *ngIf="!(!isShowDashboardToHR && loggedInUserRole == 'HR Admin')">
        <div class="d-flex phi-gap-12 dashboardInfoCard">
          <div  class="cardBox w-100 mw-sm-250 p-10 mb-md-15 cp phi-flex-center phi-gap-10" (click)="dashboardCounterPopups('noOfEmployee')">
            <div class="icon-wrapper">
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <div class="text-wrapper">
              <p class="fs-14 fs_12ForMobile font_semibold">No of Employee</p>
              <p class="mt-5 fs-14 fs_12ForMobile font_bold blue">{{noOfEmployees}}</p>
            </div>
          </div>

          <div  class="cardBox p-10 cp phi-flex-center phi-gap-10">
            <div class="icon-wrapper">
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <div class="text-wrapper">
              <p class="fs-14 fs_12ForMobile font_semibold">Scores of surveys</p>
              <p class="mt-5 fs-14 fs_12ForMobile font_bold blue">Max Avg. Score {{maxScore}} | Min Avg. Score {{minScore}} | Average score {{avgScore}}</p>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!------------------------------------ Dashboard Graphs  ------------------------------------>
    <div [hidden]="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'">
      <ion-row>
        <!-- Demographic Comparison -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Demographic Comparison</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchDemographicComparisonGraphType('bar')">
                    <img *ngIf="demographicComparisonIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="demographicComparisonIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <span (click)="switchDemographicComparisonGraphType('pie')">
                    <img *ngIf="demographicComparisonIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                    <img *ngIf="demographicComparisonIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                  </span>

                  <span (click)="switchDemographicComparisonTable()">
                    <img *ngIf="!demographicComparisonTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="demographicComparisonTable" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchDemographicComparisonGraphType('line')">
                    <img *ngIf="demographicComparisonIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="demographicComparisonIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadDemographicComparisonGraph()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-lg="3">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForDemoGraphicGraph"
                        (selectionChange)="essNamesActiveAndCompletedDemoGraphicsComparison()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="6" size-lg="4">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyIDForDemoGraphicGraph"
                        (selectionChange)="getDemographicComparisonGraph()">
                        <mat-option *ngFor="let item of essNamesListForDashboardDemoGraphicsComparison"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="12" size-lg="5">
                  <div>
                    <ng-select [clearable]="false" class="w-100 mw-sm-250 mat mat-height40" placeholder="Select Demographic"
                      [(ngModel)]="selectedDemoGraphicTypeForDemoGraphicGraph"
                      (change)="getDemographicComparisonGraph()">
                      <ng-option [value]="'Department'">Department</ng-option>
                      <ng-option [value]="'Band'">Band</ng-option>
                      <ng-option [value]="'Location'">Location</ng-option>
                      <ng-option [value]="'Gender'">Gender</ng-option>
                      <ng-option [value]="'Age'">Age</ng-option>
                      <ng-option [value]="'Experience'">Experience in Company</ng-option>
                      <ng-option [value]="'PMS'">PMS Scores</ng-option>
                    </ng-select>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : demographicComparisonTable}">
              <div id="demographicComparisonGraph" style=" height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !demographicComparisonTable}" id="demographicComparisonTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Demographic</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of demographicComparisonGraphData">
                    <td>{{item.name}}</td>
                    <td>{{item.value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>

        <!-- Completion Status -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Completion Status</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchCompletionStatusGraphType('bar')">
                    <img *ngIf="completionStatusIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="completionStatusIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <!-- <span (click)="switchCompletionStatusGraphType('pie')">
                  <img *ngIf="completionStatusIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                  <img *ngIf="completionStatusIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                </span> -->

                  <span (click)="switchCompletionStatusTable()">
                    <img *ngIf="!completionStatusTableIcon" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="completionStatusTableIcon" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchCompletionStatusGraphType('line')">
                    <img *ngIf="completionStatusIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="completionStatusIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadCompletionStatusGraph()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-lg="3">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompletionStatusGraph"
                        (selectionChange)="essNamesActiveAndCompletedCompletionStatus()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="6" size-lg="4">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyIDForCompletionStatusGraph"
                        (selectionChange)="getCompletionStatusGraph()">
                        <mat-option *ngFor="let item of essNamesListForDashboardCompletionStatus"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="12" size-lg="5">
                  <div>
                    <ng-select [clearable]="false" class="w-100 mw-sm-250 mat mat-height40 " placeholder="Select Demographic"
                      [(ngModel)]="selectedDemoGraphicTypeForCompletionStatusGraph"
                      (change)="getCompletionStatusGraph()">
                      <ng-option [value]="'Department'">Department</ng-option>
                      <ng-option [value]="'Band'">Band</ng-option>
                      <ng-option [value]="'Location'">Location</ng-option>
                      <ng-option [value]="'Gender'">Gender</ng-option>
                      <ng-option [value]="'Age'">Age</ng-option>
                      <ng-option [value]="'Experience'">Experience in Company</ng-option>
                      <ng-option [value]="'PMS'">PMS Scores</ng-option>
                    </ng-select>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : completionStatusTableIcon}">
              <div id="completionStatusGraph" style=" height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !completionStatusTableIcon}" id="completionStatusTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Demographic</th>
                    <th>Submitted</th>
                    <th>Incomplete</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of completionStatusGraphData">
                    <td>{{item.name}}</td>
                    <td>{{item.submitted}}</td>
                    <td>{{item.incomplete}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>

        <!-- Dimension Comparison -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Dimension Comparison</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchDimensionComparisonGraphType('bar')">
                    <img *ngIf="dimensionComparisonIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="dimensionComparisonIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <!-- <span (click)="switchDimensionComparisonGraphType('pie')">
                  <img *ngIf="dimensionComparisonIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                  <img *ngIf="dimensionComparisonIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                </span> -->

                  <span (click)="switchDimensionComparisonTable()">
                    <img *ngIf="!dimensionComparisonTableIcon" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="dimensionComparisonTableIcon" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchDimensionComparisonGraphType('line')">
                    <img *ngIf="dimensionComparisonIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="dimensionComparisonIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadDimensionComparisonGraph()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-md="4">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForDimensionComparisonGraph"
                        (selectionChange)="essNamesActiveAndCompletedDimensionComparison()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="6" size-md="4">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyIDForDimensionComparisonGraph"
                        (selectionChange)="getDimensionComparisonGraph()">
                        <mat-option *ngFor="let item of essNamesListForDashboardDimensionComparison"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : dimensionComparisonTableIcon}">
              <div id="dimensionComparisonGraph" style=" height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !dimensionComparisonTableIcon}">
              <table class="dashboardGraphTable" id="dimensionComparisonTable">
                <thead>
                  <tr>
                    <th>Dimension</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dimensionComparisonData">
                    <td>{{item.name}}</td>
                    <td>{{item.value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>

        <!-- Trend Analysis  -->
        <ion-col size="12" size-md="6">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Trend Analysis</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchTrendAnalysisGraphType('bar')">
                    <img *ngIf="trendAnalysisIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="trendAnalysisIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <span (click)="switchTrendAnalysisGraphType('pie')">
                    <img *ngIf="trendAnalysisIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                    <img *ngIf="trendAnalysisIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                  </span>

                  <span (click)="switchTrendAnalysisTable()">
                    <img *ngIf="!trendAnalysisTableIcon" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="trendAnalysisTableIcon" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchTrendAnalysisGraphType('line')">
                    <img *ngIf="trendAnalysisIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="trendAnalysisIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadTrendAnalysisGraph()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-lg="4">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForTrendAnalysisGraph"
                        (selectionChange)="essNamesActiveAndCompletedTrendAnalysis()">
                        <mat-option *ngFor="let item of yearsOfCompany"
                          [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
                <ion-col size="6" size-lg="4">
                  <div>
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyIDForTrendAnalysisGraph"
                        (selectionChange)="getTrendAnalysisGraph()">
                        <mat-option *ngFor="let item of essNamesListForDashboardtrendAnalysis"
                          [value]="item.id">{{item.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : trendAnalysisTableIcon}">
              <div id="trendAnalysisGraph" style=" height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !trendAnalysisTableIcon}" id="trendAnalysisTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Survey Name </th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of trendAnalysisData">
                    <td>{{item.name}}</td>
                    <td>{{item.value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>

        <!-- Demographic Trend Analysis  -->
        <ion-col size="12">
          <div class="graphs mt-20">
            <ion-row class="justify-content-center">
              <ion-col size="6" size-lg="7">
                <div class="fs-16 fs_14ForMobile font_bold">Demographic Trend Analysis</div>
              </ion-col>
              <ion-col size="6" size-lg="5">
                <div class="d-flex graph-icon">
                  <span (click)="switchDemographicTrendAnalysisGraphType('bar')">
                    <img *ngIf="demographicTrendAnalysisIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="demographicTrendAnalysisIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                  </span>

                  <!-- <span (click)="switchDemographicTrendAnalysisGraphType('pie')">
                  <img *ngIf="demographicTrendAnalysisIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                  <img *ngIf="demographicTrendAnalysisIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                  </span> -->

                  <span (click)="switchDemographicTrendAnalysisTable()">
                    <img *ngIf="!demographicTrendAnalysisTableIcon" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="demographicTrendAnalysisTableIcon" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>

                  <span (click)="switchDemographicTrendAnalysisGraphType('line')">
                    <img *ngIf="demographicTrendAnalysisIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="demographicTrendAnalysisIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                      alt="">
                  </span>

                  <span class="cp" (click)="downloadDemographicTrendAnalysisGraph()">
                    <img src="././assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size="6" size-md="3" size-lg="2">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForDemoGraphicTrendAnalysisGraph"
                      (selectionChange)="essNamesActiveAndCompletedDemographicTrendAnalysis()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col  size="12" size-md="5" size-lg="3">
                   <div  class="w-100 mw-sm-250">
                    <ng-multiselect-dropdown class="text-ellipse"  style="display: block;"
                    [placeholder]="'Select Survey'" [settings]="dropdownSettings"
                    (onSelect)="getDemographicTrendAnalysisGraph()" (onDeSelect)="getDemographicTrendAnalysisGraph()"
                    (onSelectAll)="selectAllDemographicsGraphSurvey($event)"
                    (onDeSelectAll)="onDeSelectAllDemographicsGraphSurvey()"
                    [data]="essNamesListForDashboardDemoGraphicsTrendAnalysis"
                    [(ngModel)]="selectedSurveyIDForDemoGraphicTrendAnalysisGraph">
                  </ng-multiselect-dropdown>
                   </div>
                </ion-col>
                <ion-col size="12" size-md="5" size-lg="3">
                    <ng-select [clearable]="false" class="w-100 mw-sm-250 mat mat-height40" placeholder="Select Demographic"
                      [(ngModel)]="selectedDemoGraphicTypeForDemoGraphicTrendAnalysisGraph"
                      (change)="getDemographicTrendAnalysisGraph()">
                      <ng-option [value]="'Department'">Department</ng-option>
                      <ng-option [value]="'Band'">Band</ng-option>
                      <ng-option [value]="'Location'">Location</ng-option>
                      <ng-option [value]="'Gender'">Gender</ng-option>
                      <ng-option [value]="'Age'">Age</ng-option>
                      <ng-option [value]="'Experience'">Experience in Company</ng-option>
                      <ng-option [value]="'PMS'">PMS Scores</ng-option>
                    </ng-select>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : demographicTrendAnalysisTableIcon}">
              <div id="demographicTrendAnalysisGraph" style=" height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !demographicTrendAnalysisTableIcon}" id="demographicTrendAnalysisTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Demographic</th>
                    <th *ngFor="let item of uniqueSurveyNames">{{item}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of demographicTrendAnalysisData">
                    <td>{{item.demographicName}}</td>
                    <td *ngFor="let column of uniqueSurveyNames">
                      {{
                      getScoreForGraph(item.surveys, column)
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>

    <div *ngIf="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'" class="mt-20">
      <p class="fs-14 fs_12ForMobile font_semibold" *ngIf="selectedSurveyIDForDashboardGlobal">You don't have access of dashboard for
        this ESS</p>
    </div>

    <div class="clear50"></div>
  </div>

  <!---------------------------------------- Survey Master ---------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == 'Survey Master'">
    <div class="cardBox mb-20 mt-10">
      <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
        <div class="font_bold fs-14 fs_12ForMobile">Employee Satisfaction Survey</div>
      </div>
      <div class="p-10 phi-flex-wrap-center-gap6">
        <div>
          <div class="formLabelSemiBoldfs14 mb-5">Year</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="surveyMasterYearSelectionChange()">
              <mat-option *ngFor="let item of yearsOfCompany" [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <div class="createServeyBtn">
              <button class="ess_Btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName">Submit</button>
            </div> -->
      </div>
    </div>

    <div class="phi-flex-wrap-center phi-gap-12">
      <button *ngIf="selectedSurveyMaster.length!=0" (click)="softDeleteEssByIds()" type="button" class="ess_Btn_two red fs-14 fs_12ForMobile float-right center-content">
        <span class="material-icons fs-20 mr-5 red">delete</span>
      </button>

      <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="search" placeholder="Search" [(ngModel)]="searchString" (input)="onSearchInput($event)">
      </mat-form-field>

      <div class="d-flex">
        <ion-label class="center-content ml-10 fs-14 fs_12ForMobile font_medium pr-10 black_color">Show</ion-label>
        <mat-form-field class="w70px mat-height40 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectedSizeToShowData" (selectionChange)="sizeChange()">
            <mat-option [value]="25">25</mat-option>
            <mat-option [value]="50">50</mat-option>
            <mat-option [value]="75">75</mat-option>
            <mat-option [value]="100">100</mat-option>
          </mat-select>
        </mat-form-field>
        <ion-label class="center-content fs-14 fs_12ForMobile font_medium pl-10 black_color">entries</ion-label>
      </div>
    </div>

    <div class="cardBox">
      <div class=" p-10 mt-20">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th class="w1" *ngIf="!isShowCheckBox">
                      <section class="mat-checkbox-style">
                        <mat-checkbox [(ngModel)]="isAllSurveyMaster" class="fs-12 font_semibold "
                          (change)="onSelectAllSurveyMaster($event)" [checked]="isAllSurveyMaster" value="true"
                          (click)="$event.stopPropagation()" value=true></mat-checkbox>
                      </section>
                    </th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="verticle-center icon-style">Year
                        <div class="d-flex flex-column ml-10">
                          <i class="material-icons cp" (click)="onSortAssending('fromYear')">arrow_drop_up</i>
                          <i class="material-icons cp" (click)="onSortDesending('fromYear')">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="verticle-center icon-style">Survey Name
                        <div class="d-flex flex-column ml-10">
                          <i class="material-icons cp" (click)="onSortAssending('essName')">arrow_drop_up</i>
                          <i class="material-icons cp" (click)="onSortDesending('essName')">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="verticle-center icon-style">Start date
                        <div class="d-flex flex-column ml-10">
                          <i class="material-icons cp" (click)="onSortAssending('startDate')">arrow_drop_up</i>
                          <i class="material-icons cp" (click)="onSortDesending('startDate')">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="verticle-center icon-style">End date
                        <div class="d-flex flex-column ml-10">
                          <i class="material-icons cp" (click)="onSortAssending('endDate')">arrow_drop_up</i>
                          <i class="material-icons cp" (click)="onSortDesending('endDate')">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="verticle-center icon-style">Status
                        <div class="d-flex flex-column ml-10">
                          <i class="material-icons cp" (click)="onSortAssending('status')">arrow_drop_up</i>
                          <i class="material-icons cp" (click)="onSortDesending('status')">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of listOfEss;let i = index">
                    <td *ngIf="!isShowCheckBox">
                      <section class="mat-checkbox-style">
                        <mat-checkbox *ngIf="item.essStatus == 'Pending'" [(ngModel)]="item.isChecked"
                          class="fs-12 font_semibold " (change)="onSelectSingleSurveyMaster($event,item,i)"
                          [checked]="item.isChecked" value="true" (click)="$event.stopPropagation()"
                          value=true></mat-checkbox>
                      </section>
                    </td>
                    <td><span class="fs-14 fs_12ForMobile font_regular">{{transformToYear(item?.fromYear,item?.toYear)}}</span></td>
                    <td><span class="fs-14 fs_12ForMobile font_regular yellow cp" (click)="onClickEssName(item)">{{item.essName}}</span></td>
                    <td><span class="fs-14 fs_12ForMobile font_regular">{{item.startDate | date:'dd-MM-yyyy'}}</span></td>
                    <td><span class="fs-14 fs_12ForMobile font_regular">{{item.endDate | date:'dd-MM-yyyy'}}</span></td>
                    <td><span class="fs-14 fs_12ForMobile font_regular">{{item.essStatus}}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ion-col>
        </ion-row>

        <div class="phi-flex-wrap-center-space-between-gap6">
          <div class="fs-14 fs_12ForMobile font_semibold mt-10">Showing {{(currentPage*4)-3}} to {{ (currentPage * 4) < totalCount ? (currentPage * 4) : totalCount }} of {{totalCount}} entries</div>
          <ul class="dt_pagination">
            <li class="active fs-16 fs_14ForMobile font_regular">{{currentPage}}</li>
            <span class="fs-14 fs_12ForMobile font_regular p-10 p_5pxForMobile">of {{totalNoOfPages}}</span>
            <li class="fs-24 fs_18ForMobile cp" (click)="previousPageEss()" [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
            <li class="fs-24 fs_18ForMobile cp" (click)="nextPageEss()" [ngClass]="{'disableBtn': currentPage>= totalNoOfPages}">&gt;</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------My Master------------------------------------->

  <!-- <div class="container" [style.background-color]="selectedtemplateBgColor" *ngIf="selectedTypeTabName == 'My Master'">
    <div class="cardBox mb-20 mt-10">
      <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
        <ion-row class="p-0">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="display-space-between">
              <div class="font_bold fs-14 fs_12ForMobile myMasterTableName">Employee Satisfaction Survey</div>
              <div class="verticle-center">
                <div class="verticle-center mr-20">
                  <img class="w30" src="././assets/icon/mail_white_icon.svg" alt="createEmailBody">
                  <p class="ml-5  myMasterEmail">{{loggedInUserEmail}}</p>
                </div>
                <div class="icon-container">
                  <span class="material-icons mr-10 fs-16 fs_14ForMobile">info</span>
                  <div class="tooltip">
                    <div class="info-popup">
                      <div class="p-20">
                        <h4 class="font_semibold">Instructions</h4>
                        <div class="mt-10 ml-20">
                          <ul *ngFor="let data of intructionList">
                            <li class="fs-12 text_gray">{{data}}</li>
                          </ul>
                        </div>
                        <div class="info-table mt-20">
                          <table>
                            <thead>
                              <tr>
                                <th>Question type</th>
                                <th>Rating</th>
                                <th>Rating Definition</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of ratingList">
                                <td>{{item.questionType}}</td>
                                <td>{{item.rating}}</td>
                                <td>{{item.ratingDefinition}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <ion-row>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                <mat-form-field class="w-90 mat-height40 mat-input-style">
                  <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="essNamesOfUser()">
                    <mat-option *ngFor="let item of yearsOfCompany"
                      [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
                <mat-form-field class="w-90 mat-height40 mat-input-style">
                  <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
                    (selectionChange)="isResponseSubmitted();getessByID()">
                    <mat-option *ngFor="let item of essNamesListForUser" [value]="item.id">{{item.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedSurveyStartDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                <div class="w-90 inputBoxDisabled opacity5">
                  {{selectedSurveyEndDate | date:'dd-MM-yyyy'}}
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <div class="cardBox mb-30" *ngIf="selectedSurveyName!=null">
      <div class=" p-20 mt-20">
        <div class="fs-24 fs_18ForMobile font_regular">{{selectedSurveyName}}</div>
        <div class="cardBox_two mt-20" *ngFor="let item of mySurveyQuestionList;let i =index">
          <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
          </div>
          <div class="p-20">
            <div class="fs-14 fs_12ForMobile font_regular">{{item.question}}<span class="red-cl">&nbsp;*</span></div>
            <div class="mt-10" *ngIf="item.questionType == 'Open Ended'">
              <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
                <textarea matInput [disabled]="isResponseSubmittedMySurvey" placeholder="Enter your Answer" rows="1"
                  maxlength="255" [(ngModel)]="item.answer"></textarea>
              </mat-form-field>
            </div>
            <div class="mt-10 myServayRatingBaseQuestionType" *ngIf="item.questionType == 'Rating Based'">
              <div class="ml-10" *ngFor="let data of ratingListOnRatingBased; let j = index;let isLast = last">
                <div class="rating_btn w100 cp" [ngClass]="{'selectedAnswer': item.answer == data.rating}"
                  (click)="onClickRating(item,data,i)">{{ data.rating }}</div>
                <div class="text-center fs-12 mt-5 text_gray" *ngIf="j==0 || isLast || item.answer == data.rating">
                  {{ data?.ratingDefinition }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="mt-20">
              <button [ngClass]="{'disableBtn':isResponseSubmittedMySurvey}" [disabled]="isResponseSubmittedMySurvey"
                class="ess_Btn fs-14 fs_12ForMobile" (click)="submitMySurveyResponse()"
                [style.background-color]="selectedTemplateColorCode">
                Submit
              </button>
              <label *ngIf="isResponseSubmittedMySurvey" class="fs-14 fs_12ForMobile font_regular ml-15">Submitted on {{submissionDate
                | date: 'dd-MM-yyyy | hh:mm a'}}</label>
            </div>
          </ion-col>
        </ion-row>

      </div>
    </div>
  </div> -->


  <ng-container *ngIf="selectedTypeTabName == 'My Master' ">
    <div class="container" [style.background-color]="selectedtemplateBgColor">
      <div  class="surveymsg"  *ngIf="isSurveyCompleted() == 'Completed'">
      Your Survey is expired
       </div>
      <div class="cardBox mb-20 mt-10">
        <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
          <ion-row class="p-0">
            <ion-col size="12">
              <div class="phi-flex-wrap-center-space-between phi-gap-12">
                <div class="font_bold fs-14 fs_12ForMobile myMasterTableName">Employee Satisfaction Survey</div>
                <div class="w-sm-100 phi-flex-center ion-justify-content-between phi-gap-12">
                  <div class="verticle-center mr-20">
                    <img class="w30" src="././assets/icon/mail_white_icon.svg" alt="createEmailBody">
                    <p class="ml-5  myMasterEmail">{{loggedInUserEmail}}</p>
                  </div>
                  <div class="icon-container">
                    <span class="material-icons mr-10 fs-16 fs_14ForMobile">info</span>
                    <div class="tooltip">
                      <div class="info-popup">
                        <div class="p-20">
                          <h4 class="font_semibold">Instructions</h4>
                          <div class="mt-10 ml-20">
                            <ul *ngFor="let data of intructionList">
                              <li class="fs-12 text_gray">{{data}}</li>
                            </ul>
                          </div>
                          <div class="info-table mt-20">
                            <table>
                              <thead>
                                <tr>
                                  <th>Question type</th>
                                  <th>Rating</th>
                                  <th>Rating Definition</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let item of ratingList">
                                  <td>{{item.questionType}}</td>
                                  <td>{{item.rating}}</td>
                                  <td>{{item.ratingDefinition}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </div>
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <ion-row>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                  <mat-form-field class="w-90 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="essNamesOfUser()" [disabled]="isSurveyCompleted()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
             
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
                  <mat-form-field class="w-90 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
                      (selectionChange)="isResponseSubmitted();getessByID()" [disabled]="isSurveyCompleted()">
                      <mat-option *ngFor="let item of essNamesListForUser" [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                  <div class="w-90 inputBoxDisabled opacity5">
                    {{selectedSurveyStartDate | date:'dd-MM-yyyy'}}
                  </div>
                </ion-col>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                  <div class="w-90 inputBoxDisabled opacity5">
                    {{selectedSurveyEndDate | date:'dd-MM-yyyy'}}
                  </div>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </div>
 
      <div class="cardBox mb-30" *ngIf="selectedSurveyName!=null">
        <div class="p-20 mt-20">
          <div class="fs-24 fs_18ForMobile font_regular">{{selectedSurveyName}}</div>
          <div class="cardBox_two mt-20" *ngFor="let item of mySurveyQuestionList;let i =index">
            <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode"></div>
            <div class="p-20">
              <div class="fs-14 fs_12ForMobile font_regular">{{item.question}}<span class="red-cl">&nbsp;*</span></div>
  
              <div class="mt-10" *ngIf="item.questionType == 'Open Ended'">
                <mat-form-field class="custom-input w-100  mat-input-style">
                  <textarea matInput [disabled]="isResponseSubmittedMySurvey || isSurveyCompleted() == 'Completed'" placeholder="Enter your Answer" rows="1"
                    maxlength="255" [(ngModel)]="item.answer"></textarea>
                </mat-form-field>
        
 
              </div>
              
              <div class="mt-10 myServayRatingBaseQuestionType" *ngIf="item.questionType == 'Rating Based'">
                <div class="ml-10" *ngFor="let data of ratingListOnRatingBased; let j = index; let isLast = last">
                  <div class="rating_btn w100 cp"
                    [ngClass]="{'selectedAnswer': item.answer == data.rating, 'disabled': isSurveyCompleted()=='Completed'}"
                    (click)="(isSurveyCompleted() != 'Completed') && onClickRating(item,data,i)">
                    {{ data.rating }}
                  </div>
                  <div class="text-center fs-12 mt-5 text_gray"
                  *ngIf="j==0 || isLast || item.answer == data.rating"
                  [matTooltip]="data?.ratingDefinition"
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above">
               {{ data?.ratingDefinition?.length > 15 
                   ? (data?.ratingDefinition | slice:0:15) + '...' 
                   : data?.ratingDefinition }}
             </div>
             
                </div>
              </div>
            </div>
          </div>
  
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="mt-20">
                <button
                  [ngClass]="{'disableBtn': isResponseSubmittedMySurvey || isSurveyCompleted() !== 'Active'}"
                  [disabled]="isResponseSubmittedMySurvey || isSurveyCompleted() !== 'Active'"
                  class="ess_Btn fs-14 fs_12ForMobile"
                  (click)="submitMySurveyResponse()"
                  [style.background-color]="selectedTemplateColorCode">
                  Submit
                </button>
                <label *ngIf="isResponseSubmittedMySurvey" class="fs-14 fs_12ForMobile font_regular ml-15">
                  Submitted on {{submissionDate | date: 'dd-MM-yyyy | hh:mm a'}}
                </label>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
  </ng-container>
  

  
  <!-- --------------------------------------Reports------------------------------------->

  <div class="container" *ngIf="selectedTypeTabName == 'Reports'">
    <ion-row class="pl-0 pt-5 pb-5 pr-5">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5">
        <div class="essReportsTabGroup">
          <button *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
          || loggedInUserRole == 'PHI Admin'" [ngClass]="{'activeSubTaskTab': selectedSubTab === 'Completion Report'}"
            (click)="showScoreCardReport('Completion Report')" type="button"
            class="essReportsBtnTab center-content fs-12 mr-5">
            <span class="displayContent">Completion Report</span>
          </button>

          <button *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
          || loggedInUserRole == 'PHI Admin'"
            [ngClass]="{'activeSubTaskTab': selectedSubTab === 'Question Wise Report'}"
            (click)="showScoreCardReport('Question Wise Report')" type="button"
            class="essReportsBtnTab center-content fs-12 mr-5">
            <span class="displayContent">Question Wise Report</span>
          </button>

          <button *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
          || loggedInUserRole == 'PHI Admin'"
            [ngClass]="{'activeSubTaskTab': selectedSubTab === 'Dimension wise report'}"
            (click)="showScoreCardReport('Dimension wise report')" type="button"
            class="essReportsBtnTab center-content fs-12 mr-5">
            <span class="displayContent">Dimension wise report</span>
          </button>

          <button *ngIf="loggedInUserRole == 'Admin' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
          || loggedInUserRole == 'PHI Admin'"
            [ngClass]="{'activeSubTaskTab': selectedSubTab === 'Demographic Wise Report'}"
            (click)="showScoreCardReport('Demographic Wise Report')" type="button"
            class="essReportsBtnTab center-content fs-12 mr-5">
            <span class="displayContent">Demographic Wise Report</span>
          </button>

          <button
            *ngIf=" loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Employee'"
            [ngClass]="{'activeSubTaskTab': selectedSubTab === 'Score Trend'}"
            (click)="showScoreCardReport('Score Trend')" type="button"
            class="essReportsBtnTab center-content fs-12 mr-5">
            <span class="displayContent">Score Trend</span>
          </button>

        <!-- <div class="isShowDesktopView"> -->
          <button *ngIf="loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'"
          [ngClass]="{'activeSubTaskTab': selectedSubTab === 'Master / Dump'}"
          (click)="showScoreCardReport('Master / Dump')" type="button"
          class="essReportsBtnTab center-content fs-12 mr-5">
          <span class="displayContent">Master / Dump</span>
        </button>
        <!-- </div> -->
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-md="3" size-lg="2">
        <!-- <div> -->
          <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="essNamesForReports()">
              <mat-option *ngFor="let item of yearsOfCompany"
                [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
        <!-- </div> -->
      </ion-col>
      <ion-col size="12" size-md="3" size-lg="2"
      *ngIf="selectedSubTab == 'Completion Report'||selectedSubTab == 'Question Wise Report'|| 
      selectedSubTab == 'Dimension wise report' || selectedSubTab == 'Demographic Wise Report'">
        <!-- <div> -->
          <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
            <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
              (selectionChange)="getessByID();onChangeSurveyNameOfReport()">
              <mat-option *ngFor="let item of essNamesListForReports" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        <!-- </div> -->
      </ion-col>
      <ion-col size="12" size-md="3" size-lg="2" 
      *ngIf="selectedSubTab == 'Demographic Wise Report'">
        <!-- <div> -->
          <ng-select [clearable]="false" class="w-100 mw-sm-250 mat mat-height40" placeholder="Select Demographic"
            [(ngModel)]="demographicType" (change)="onChangeSurveyNameOfReport()">
            <ng-option [value]="'Department'">Department</ng-option>
            <ng-option [value]="'Band'">Band</ng-option>
            <ng-option [value]="'Location'">Location</ng-option>
            <ng-option [value]="'Gender'">Gender</ng-option>
            <ng-option [value]="'Age'">Age</ng-option>
            <ng-option [value]="'Experience'">Experience in Company</ng-option>
            <ng-option [value]="'PMS'">PMS Scores</ng-option>
          </ng-select>
        <!-- </div> -->
      </ion-col>

      <!--   Dropdown for the score Trend Report    -->

      <ion-col size
      *ngIf="selectedSubTab == 'Score Trend' || selectedSubTab == 'Master / Dump'">
      <div class="w-100 mw-sm-250">
        <ng-multiselect-dropdown class="text-ellipse" [placeholder]="'Select Survey'" [settings]="dropdownSettings"
          (onSelect)="onSelectEssReportScoreTrend()" (onDeSelect)="onDeSelectEssReportScoreTrend()"
          (onSelectAll)="selectAllEssReportScoreTrend($event)" (onDeSelectAll)="onDeSelectAllEssReportScoreTrend()"
          [data]="essNamesListForReports" [(ngModel)]="multipleSelectedEssIDs">
        </ng-multiselect-dropdown>
        </div>
      </ion-col>
    </ion-row>
    <div *ngIf="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'">
      <p class="fs-14 fs_12ForMobile font_semibold" *ngIf="selectedSurveyIDForDashboardGlobal">You don't have access of reports for
        this ESS</p>
    </div>
    <div [hidden]="!isShowDashboardToHR && loggedInUserRole == 'HR Admin'">
      <div *ngIf="selectedSubTab == 'Completion Report'">
        <ion-row class="reportsSubTabInput">
          <ion-col size="12" size-md>
            <ng-multiselect-dropdown class="w-100 mw-sm-250" [placeholder]="'Select Location'"
              [settings]="dropdownSettings" (onSelect)="getBandsListForEssForReport()" (onDeSelect)="onDeSelectLocationSetup()"
              (onSelectAll)="selectAllLocationSetup($event)" (onDeSelectAll)="onDeSelectAllLocationSetup()"
              [data]="getLocationListForReport" [(ngModel)]="selectedLocationForSetup">
            </ng-multiselect-dropdown>
          </ion-col>

          <ion-col size="12" size-md>
            <ng-multiselect-dropdown class="w-100 mw-sm-250" [placeholder]="'Select Band'" [settings]="dropdownSettings"
              (onSelect)="getGradesListForEssForReport()" (onDeSelect)="onDeSelectBandSetup()"
              (onSelectAll)="selectAllBandSetup($event)" (onDeSelectAll)="onDeSelectAllBandSetup()"
              [data]="getBandListForReport" [(ngModel)]="selectedBandForSetup">
            </ng-multiselect-dropdown>
          </ion-col>

          <ion-col size="12" size-md>
            <ng-multiselect-dropdown class="w-100 mw-sm-250" [placeholder]="'Select Grade'" [settings]="dropdownSettings"
              (onSelect)="getDeptListForEssForReport()" (onDeSelect)="onDeSelectGradeSetup()"
              (onSelectAll)="selectAllGradeSetup($event)" (onDeSelectAll)="onDeSelectAllGradeSetup()"
              [data]="getGradeListForReport" [(ngModel)]="selectedGradeForSetup">
            </ng-multiselect-dropdown>
          </ion-col>

          <ion-col size="12" size-md>
            <ng-multiselect-dropdown class="w-100 mw-sm-250" [placeholder]="'Select Function'"
              [settings]="dropdownSettings" (onSelect)="getEmpListForEssForReport()" (onDeSelect)="onDeSelectFunctionSetup()"
              (onSelectAll)="selectAllFunctionReport($event)" (onDeSelectAll)="onDeSelectAllFunctionReport()"
              [data]="getFunctionListForReport" [(ngModel)]="selectedFunctionForSetup">
            </ng-multiselect-dropdown>
          </ion-col>

          <ion-col size="12" size-md>
            <ng-multiselect-dropdown class="w-100 mw-sm-250" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
              (onSelect)="getCompletionReport()" (onDeSelect)="getCompletionReport()"
              (onSelectAll)="selectAllEmployeeRport($event)" (onDeSelectAll)="onDeSelectAllEmployeeRport()"
              [data]="listOfEmployeesForReport" [(ngModel)]="selectedEmployeeForReport">
            </ng-multiselect-dropdown>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="cardBox p-20">
              <div class="display-space-between">
                <div>
                  <mat-form-field class="mat-height40 w-100 max-w-180 mw-sm-250 mat-input-style">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                      (input)="onSearchInputReport($event)">
                  </mat-form-field>
                </div>
                <div>
                  <button (click)="downloadReportExcel('CompletionReport')"
                    class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                    <span class="material-icons">download</span>
                  </button>
                </div>
              </div>

              <div class="reportsTable-container mt-20">
                <table id="CompletionReport">
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Band</th>
                      <th>Grade</th>
                      <th>Function</th>
                      <th>Employee</th>
                      <th>Completion Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let item of getCompletionReportList">
                      <ng-container *ngFor="let band of item.bands">
                        <ng-container *ngFor="let grade of band.grades">
                          <ng-container *ngFor="let dept of grade.depts">
                            <ng-container *ngFor="let emp of dept.employees">
                              <tr>
                                <td
                                  *ngIf="band === item.bands[0] && grade === band.grades[0] && dept === grade.depts[0] && emp === dept.employees[0]"
                                  [attr.rowspan]="calculateRowspanForLocation(item)">
                                  {{ item.locationName }}
                                </td>
                                <td
                                  *ngIf="grade === band.grades[0] && dept === grade.depts[0] && emp === dept.employees[0]"
                                  [attr.rowspan]="calculateRowspanForBand(band)">
                                  {{ band.band }}
                                </td>
                                <td *ngIf="dept === grade.depts[0] && emp === dept.employees[0]"
                                  [attr.rowspan]="calculateRowspanForGrade(grade)">
                                  {{ grade.grade }}
                                </td>
                                <td *ngIf="emp === dept.employees[0]" [attr.rowspan]="dept.employees.length">
                                  {{ dept.department }}
                                </td>
                                <td>{{ emp.employeeName }}</td>
                                <td>
                                  {{ emp.completionStatus }}
                                  <span *ngIf="emp.completionDate"> | {{ emp.completionDate|date:'dd-MM-yyyy' }}</span>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>


              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="selectedSubTab == 'Question Wise Report'">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="cardBox p-20">
              <div class="reportSubTabsContent">
                <div class="verticle-center">
                  <mat-form-field class="mat-height40 w-100 mw-sm-250 mat-input-style">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                      (input)="onSearchInputReport($event)">
                  </mat-form-field>
                </div>

                <div *ngIf="questionWiseReportList?.length > 0"  class="phi-flex-wrap-center phi-gap-12">
                  <div class="fs-12 font_semibold mr-20">Total Average score of Survey = {{totalAvgScoreOfSurveyReport}}
                  </div>
                  <div class="fs-12 font_semibold mr-40">No. Of Employees = {{noOfEmpsReport}}</div>
                  <div>
                    <button (click)="downloadReportExcel('QuestionWiseReport')" class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                      <span class="material-icons">download</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- <ion-row class="verticle-center">
                <ion-col size-sm="12" size-md="6" size-lg="11" size-xs="12">
                  <ion-row class="verticle-center">
                    <ion-col size-sm="12" size-md="6" size-lg="7" size-xs="12">
                      <mat-form-field class="mat-height40 w-100 mw-sm-250 mat-input-style">
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                          (input)="onSearchInputReport($event)">
                      </mat-form-field>
                    </ion-col>
                    <ion-col size-sm="12" size-md="12" size-lg="3" size-xs="12">
                      <div class="fs-12 font_semibold mr-20">Total Average score of Survey = {{totalAvgScoreOfSurveyReport}}
                      </div>
                    </ion-col>
                    <ion-col size-sm="12" size-md="12" size-lg="2" size-xs="12">
                      <div class="fs-12 font_semibold mr-40">No. Of Employees = {{noOfEmpsReport}}</div>
                    </ion-col>
                  </ion-row>
                </ion-col>
                <ion-col size-sm="12" size-md="12" size-lg="1" size-xs="12">
                  <button (click)="downloadReportExcel('QuestionWiseReport')"
                    class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold float-right">
                    <span class="material-icons">download</span>
                  </button>
                </ion-col>
              </ion-row> -->

              <div class="reportsTable-container mt-20">
                <table id="QuestionWiseReport">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>{{selectedSurveyName}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of questionWiseReportList">
                      <td>{{item.question}}</td>
                      <td>{{item.score}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="selectedSubTab == 'Dimension wise report'">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="cardBox p-20">
              <div class="reportSubTabsContent">
                <div class="verticle-center">
                  <mat-form-field class="mat-height40 w-100 mw-sm-250 mat-input-style">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                      (input)="onSearchInputReport($event)">
                  </mat-form-field>
                </div>
      
                <!-- Show header only if data is present -->
                <div *ngIf="hasDimensionData" class="phi-flex-wrap-center phi-gap-12">
                  <div class="fs-12 font_semibold mr-20">
                    Total Average score of Survey = {{totalAvgScoreOfSurveyReport}}
                  </div>
                  <div class="fs-12 font_semibold mr-40">
                    No. Of Employees = {{noOfEmpsReport}}
                  </div>
                  <div>
                    <button (click)="downloadReportExcel('DimensionWiseReport')"
                      class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                      <span class="material-icons">download</span>
                    </button>
                  </div>
                </div>
              </div>
      
              <div class="reportsTable-container mt-20">
                <table id="DimensionWiseReport">
                  <thead>
                    <tr>
                      <th>Dimension</th>
                      <th>Question</th>
                      <th>Score</th>
                      <th>Avg. Dimension Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let item of dimensionsWiseReportList; let i = index">
                      <ng-container *ngFor="let data of item?.questions">
                        <tr>
                          <td *ngIf="data == item.questions[0]" [attr.rowspan]="item?.questions.length">
                            {{ item.dimensionName }}
                          </td>
                          <td>{{ data.question }}</td>
                          <td>{{ data.score }}</td>
                          <td *ngIf="data == item.questions[0]" [attr.rowspan]="item?.questions.length">
                            {{ item.avgDimensionScore }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
      

      <div *ngIf="selectedSubTab == 'Demographic Wise Report'">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="cardBox p-20">
              <div>
                <ion-row >
                  <ion-col size-sm="10" size-md="4" size-lg="3" size-xs="10">
                    <mat-form-field class="mat-height40 w-100 max-w-180 mw-sm-250 mat-input-style">
                      <mat-icon matPrefix>search</mat-icon>
                      <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                        (input)="onSearchInputReport($event)">
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="2" size-md="8" size-lg="9" size-xs="2">
                    <div class="float-right">
                      <button (click)="downloadReportExcel('DemographicWiseReport')"
                        class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                        <span class="material-icons">download</span>
                      </button>
                    </div>
                  </ion-col>
                </ion-row>
              </div>

              <div class="reportsTable-container mt-20">
                <table id="DemographicWiseReport">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th *ngFor="let list of columnsNamesOfDemographicsTable">{{list}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of demographicWiseReportList">
                      <td>{{ item.question }}</td>
                      <td *ngFor="let column of columnsNamesOfDemographicsTable">
                        {{
                        getScore(item.scores, column)
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Avg. {{demographicType}} Score</td>
                      <td *ngFor="let column of columnsNamesOfDemographicsTable">
                        {{ getAverageScore(column) }}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="selectedSubTab == 'Score Trend' && isPublished && isResponseSubmittedMySurvey">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="cardBox p-20">
              <div>
                <ion-row>
                  <ion-col size-sm="10" size-md="4" size-lg="3" size-xs="10">
                    <mat-form-field class="mat-height40 w-100 max-w-180 mw-sm-250 mat-input-style">
                      <mat-icon matPrefix>search</mat-icon>
                      <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                        (input)="onSearchInputReport($event)">
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="2" size-md="8" size-lg="9" size-xs="2">
                    <div class="float-right">
                      <button (click)="downloadReportExcel('ScoreTrendReport')"
                        class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                        <span class="material-icons">download</span>
                      </button>
                    </div>
                  </ion-col>
                </ion-row>
              </div>

              <div class="reportsTable-container mt-20">
                <table id="ScoreTrendReport" >
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th *ngFor="let list of columnsNamesOfScoreTrendReport">{{list}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of getScoreTrendReportList">
                      <td>{{ item.question }}</td>
                      <td *ngFor="let column of columnsNamesOfScoreTrendReport">
                        {{
                        getScoreOfScoretrend(item.scores, column)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div *ngIf="selectedSubTab == 'Master / Dump'">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="cardBox p-20">
              <div class="display-space-between">
                <div class="verticle-center">
                  <mat-form-field class="mat-height40 w-100 max-w-180 mw-sm-250 mat-input-style">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
                      (input)="onSearchInputReport($event)">
                  </mat-form-field>

                </div>
                <div class="verticle-center">
                  <div>
                    <button (click)="downloadReportExcel('MasterDumpReport')"
                      class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold">
                      <span class="material-icons">download</span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="reportsTable-container mt-20" *ngFor="let item of getMasterDumpReportList">
                <div class="fs-16 fs_14ForMobile font_medium mb-5">{{item.surveyName}}</div>
                <table id="MasterDumpReport">
                  <thead>
                    <tr>
                      <th rowspan="2">Employee Name</th>
                      <th rowspan="2">Band</th>
                      <th rowspan="2">Department</th>
                      <th [attr.colspan]="dimension.questions.length"
                        *ngFor="let dimension of item.dimensionWiseAverages">{{dimension.dimensionName}}</th>
                      <th rowspan="2">Average Score</th>
                    </tr>
                    <tr>
                      <ng-container *ngFor="let dimension of item.dimensionWiseAverages">
                        <th *ngFor="let question of dimension.questions">
                          {{ question.questionText }}
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let employee of item.employeeScores">
                      <td>{{ employee.employeeName }}</td>
                      <td>{{ employee.band }}</td>
                      <td>{{ employee.department }}</td>
                      <ng-container *ngFor="let dimension of employee.dimensions">
                        <td *ngFor="let question of dimension.questions">
                          {{ getScore1(employee, dimension.dimensionName, question.questionText) }}
                        </td>
                      </ng-container>
                      <td>{{ employee.employeeAverage | number:'1.2-2'}}</td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colspan="3">Average Score</td>
                      <ng-container *ngFor="let dimension of item.dimensionWiseAverages">
                        <td *ngFor="let question of dimension.questions">
                          {{question.averageScore | number:'1.2-2'}}
                        </td>
                      </ng-container>
                      <td>{{item?.averageScore | number:'1.2-2'}}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>

</ion-content>
